<template>
  <div class="radio-btn mt-1" @click="toggle">
    <div class="thing-container">
      <div class="thing" :class="{ active: modelValue }">
        <i v-if="modelValue" class="bi bi-check2"></i>
      </div>
    </div>

    <div class="radio-text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RadioButton",

  props: {
    text: { type: String, required: true },

    /* значение снаружи */
    modelValue: { type: Boolean, default: false }
  },

  methods: {
    toggle() {
      this.$emit("update:modelValue", true); // как радио — выбирается только true
      this.$emit("select"); // событие выбора (если нужно)
    }
  }
};
</script>

<style scoped>
.radio-btn{
  display: flex;
  align-items: center;
  cursor: pointer;
}

.thing-container{
  width: 1rem;
  height: 1rem;
  margin-right: 8px;
}

.thing{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #555;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  color: white;
  transition: 0.2s;
}

.thing i {
  margin-top: -1px;
  margin-left: -1px;
}

.thing.active{
  background-color: #000;
}
</style>
